import veritoneApi from './veritoneApi';
import _ from 'lodash';

const SDO_SEARCH_INDEX = [
    'mine',
    'global'
];
const SDO_SEARCH_LIMIT = 50;
const SDO_SEARCH_OFFSET = 0;
const SDO_SEARCH_SCHEMA_ID = '1f2f7561-f067-4c08-948d-4f9827451fa6';

export function searchBarApi(urlApi, query, token){
    return veritoneApi(urlApi.searchBar, token).post("", {
        "query": query.query,
        "select": query.select,
        "limit": query.limit,
        "index":query.index,
        "offset":query.offset
    })
        .then(response => _.get(response, 'data.results', []))
        .catch(error => error)
}

export function searchBarAggregateApi(urlApi, query, token){
    return veritoneApi(urlApi.searchBarAggregate, token).post("", {
        "query": query.query,
        "select": query.select,
        "limit": query.limit,
        "index":query.index,
        "offset":query.offset,
        "aggregate": query.aggregate
    })
      .then(response => _.get(response, 'data.aggregations', []))
      .catch(error => error)
}

export function sdoSearchApi(urlApi, query, token){
    const payload = {
        "limit": SDO_SEARCH_LIMIT,
        "index": SDO_SEARCH_INDEX,
        "offset": SDO_SEARCH_OFFSET,
        "type": SDO_SEARCH_SCHEMA_ID,
        "query": query.query,
    }
    return veritoneApi(urlApi.searchBar, token).post("", payload)
        .then(response => _.get(response, 'data.results', []))
        .catch(error => error)
}

export function sdoSearchAggregateApi(urlApi, query, token){
    const payload = {
        "limit": SDO_SEARCH_LIMIT,
        "index": SDO_SEARCH_INDEX,
        "offset": SDO_SEARCH_OFFSET,
        "type": SDO_SEARCH_SCHEMA_ID,
        "query": query.query,
        "aggregate": query.aggregate
    }
    return veritoneApi(urlApi.searchBarAggregate, token).post("", payload)
      .then(response => _.get(response, 'data.aggregations', []))
      .catch(error => error)
}

export function fixV3QueryCondition(query){
    const conditions = _.get(query, 'conditions');
    if (conditions){
        for (var condition of conditions){
            if (_.startsWith(_.get(condition, 'field'), 'sdo_station_pl_1_5_p_6_gaixjxp.series.')) {
                condition.field = condition.field.replace('sdo_station_pl_1_5_p_6_gaixjxp.series.','');
                condition.field = condition.field.replace('.string','');
            }
        }
        const subconditions=_.get(condition,'conditions');
        if (subconditions){
            fixV3QueryCondition(condition);
        }
    }
}

export function getPreRecordQuery(originalSearchQuery, stations, startDate, endDate) {
    const { callsigns, bands } = stations.reduce((acc, station) => {
        const { callsigns, bands } = acc;
        const { stationCallSign, stationBand } = station;
        callsigns.push(stationCallSign);
        bands.push(stationBand);
        return acc;
    },
    {
        callsigns: [],
        bands: []
    });
    const searchQuery = _.cloneDeep(originalSearchQuery);
    fixV3QueryCondition(searchQuery.query);//fix condtion to remove sdo_station_pl_1_5_p_6_gaixjxp.series. 

    callsigns.length > 0 && searchQuery.query.conditions.push(
        {
            "operator": "terms",
            "field": "stationCallLetters",
            "values": _.uniq(callsigns)
        }
    );
    bands.length > 0 && searchQuery.query.conditions.push(
        {
            "operator": "terms",
            "field": "stationBand",
            "values": _.uniq(bands)
        }
    );
    startDate && searchQuery.query.conditions.push({
        "operator": "range",
        "field": "startDateTime",
        "gte": startDate
    });
    endDate && searchQuery.query.conditions.push({
        "operator": "range",
        "field": "endDateTime",
        "lte": endDate
    });
    const aggregateSearchQuery = {
        ...searchQuery,
        aggregate: [
            {
                "name": "stationCallLetters",
                "field": "stationCallLetters",
                "operator": "term"
            },
            {
                "name": "adsPerDay",
                "field": "startDateTime",
                "operator": "date",
                "format": "MM/dd",
                "interval": "day"
            }
        ]
    };

    return {
        preRecordSearchQuery: searchQuery,
        aggregatePreRecoedSearchQuery: aggregateSearchQuery
    }
}